<i18n>
{
  "en": {
    "menuFilter": "Filter by menu",
    "serviceFilter": "Filter by service",
    "isActiveByDefault": "Filter by default recommendation",
    "all": "All",
    "yes": "Yes",
    "no": "No"
  },
  "es": {
    "menuFilter": "Filtrar por menú",
    "serviceFilter": "Filtrar por servicio",
    "isActiveByDefault": "Filtrar por recomendación por defecto",
    "all": "Todos",
    "yes": "Si",
    "no": "No"
  }
}
</i18n>

<template>
  <v-row align="end">
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4">
      <v-select multiple v-model="filterByMenu" :items="menuList" item-text="title" chips
                item-value="guid" :label="$t('menuFilter')" hide-details @change="onSelectMenu"/>
    </v-col>
    <v-col class="d-flex mt-lg-4 mt-md-4" cols="12" sm="4">
      <v-select v-model="filterDefault" :items="selectorBooleanTags" :label="$t('isActiveByDefault')"
                dense hide-details @change="onSelectActiveByDefault"/>
    </v-col>
  </v-row>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class RecommendationFilter extends Vue {
  @Prop({ type: Array, default: true }) menuList;

  filterByMenu = [];

  filterDefault = 'all';

  get selectorBooleanTags() {
    return [
      { text: this.$t('all'), value: 'all' },
      { text: this.$t('yes'), value: 'yes' },
      { text: this.$t('no'), value: 'no' }
    ];
  }

  onSelectMenu() {
    this.$emit('menu', this.filterByMenu);
  }

  onSelectActiveByDefault(emitted) {
    this.$emit('default', emitted);
  }
}

</script>
